const styles = {
  round: "round",
  icon: "icon",
  image: "image",
  imageSmall: "image-small",
};

const stepStyle = [
  styles.image,
  styles.imageSmall,
  styles.imageSmall,
  styles.image,
];

export { stepStyle, styles };
